export default "__VITE_ASSET__liWS7bas__"